module.exports = __webpack_public_path__ + "img/zero.4e425221.png";